import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, saveEntryDraft } from 'store/data/entries';

type HandlerInput = Parameters<typeof saveEntryDraft>;

export function useSaveEntryDraft(): Operation<(...input: HandlerInput) => void> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(ActionTypes.SAVE_ENTRY_DRAFT);

	function handler(...input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		dispatch(saveEntryDraft(...input));
	}

	return [{ loading, error }, handler];
}
